import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { yamazaki_brown } from '../styles/color';
import { getRecruitJobs } from '../apis';
import { appGetLocale, appJobNatureDict, appPathPrefix, isMobileAspectRatio } from '../helpers/appHelper';

const Jobs = () => {
    const params = useParams();
    const nav = useNavigate();
    const location = useLocation();
    const [jobType, setJobType] = useState([]);
    const [jobList, setJobList] = useState([]);
    const [selectedJobId, setSelectedJobId] = useState(params.jobId || null);
    const job_nature_dict = appJobNatureDict();
    const prefix = appPathPrefix();
    const isMobile = isMobileAspectRatio();
    const appLanguage = appGetLocale();
    const isEng = appLanguage === 'en';

    useEffect(() => {
        const nature = params.jobsNature;
        if (nature !== 'baker' && nature !== 'sales' && nature !== 'logistics' && nature !== 'factory' && nature !== 'office') {
            nav(prefix + '/')
        }
        else {
            getData();
        }
    }, [params.jobsNature]);

    useEffect(() => {
        const path_params = new URLSearchParams(location.search);
        const job_id = path_params.get('jobId');
        if (job_id !== null && job_id != selectedJobId) {
            setSelectedJobId(job_id);
        }
    }, [location]);

    const getData = async () => {
        const result = await getRecruitJobs({ job_nature: job_nature_dict[params.jobsNature] });
        if (!result.fail) {
            setJobList(result);
        }
    };

    const handleJobClick = (jobId) => {
        setSelectedJobId(jobId === selectedJobId ? null : jobId);
        nav(prefix + `/careers/${params.jobsNature}${jobId === selectedJobId ? '' : '?jobId=' + jobId}`);
    };

    const filteredJobList = () => {
        return jobList.filter(job => {
            if (jobType.length === 0) return true;
            if (jobType.includes('full') && job.type === 'FULL_TIME') return true;
            if (jobType.includes('part') && job.type === 'PART_TIME') return true;
            return false;
        });
    };

    const NavBar = () => (
        isMobile ?
        <div className="jobs-nav">
            <a href={prefix + "/"} style={{ color: yamazaki_brown, textDecoration: 'none' }}>
                <span>
                    <FormattedMessage id={'menus.home'} />
                </span>
            </a>
            <span> {">"} </span>
            <a href={prefix + "/careers"} style={{ color: yamazaki_brown, textDecoration: 'none' }}>
                <span>
                    <FormattedMessage id={'menus.recruit'} />
                </span>
            </a>
            <span> {">"} </span>
            <span style={{ fontWeight: 'bold' }}>
                {
                    params.jobsNature === 'baker' ?
                    <FormattedMessage id={'recruit.staffBakerMobile'} /> :
                    params.jobsNature === 'sales' ?
                    <FormattedMessage id={'recruit.staffSalesMobile'} /> :
                    params.jobsNature === 'logistics' ?
                    <FormattedMessage id={'recruit.staffLogistics'} /> :
                    params.jobsNature === 'factory' ?
                    <FormattedMessage id={'recruit.staffFactory'} /> :
                    <FormattedMessage id={'recruit.staffOfficeMobile'} />
                }
            </span>
        </div>
        :
        <div className="jobs-nav">
            <a href={prefix + "/careers"} style={{ color: yamazaki_brown, textDecoration: 'none' }}>
                <span>
                    <FormattedMessage id={'jobs.selectJobNature'} />
                </span>
            </a>
            <span> {">"} </span>
            <span style={{ fontWeight: 'bold' }}>
                <FormattedMessage id={'jobs.jobApplication'} />
            </span>
        </div>
    );

    const JobsContent = () => {
        const changeJobType = (change_to) => {

            setJobType(prev => {
                if (prev.includes(change_to)) {
                    return prev.filter(type => type !== change_to);
                } else {
                    return [...prev, change_to];
                }
            });
            setSelectedJobId(null);
            nav(prefix + `/careers/${params.jobsNature}`);
        };

        return (
            <div className='jobs-content'>
                <div className="jobs-type">
                    <div className="jobs-full-time">
                        <label>
                            <input type="checkbox" checked={jobType.includes('full')} onChange={() => changeJobType('full')} />
                            <FormattedMessage id={'jobs.jobFullTime'} />
                        </label>
                    </div>
                    <div className="jobs-part-time">
                        <label>
                            <input type="checkbox" checked={jobType.includes('part')} onChange={() => changeJobType('part')} />
                            <FormattedMessage id={'jobs.jobPartTime'} />
                        </label>
                    </div>
                </div>
                <div className="jobs-list">
                    {filteredJobList().map(job => (
                        isMobile ?
                        <div key={job.id} className='jobs-list-item-container'>
                            <div className="jobs-list-item" onClick={() => handleJobClick(job.id)}>
                                <div className="jobs-list-item-date">
                                    {job.date_from_str?.substring(0, 10)}
                                </div>
                                <div className="jobs-list-item-content">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                        <div className="jobs-list-item-name">
                                            {job.name}
                                        </div>
                                        <div style={{ width: '10%' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.243" height="8.621" viewBox="0 0 14.243 8.621">
                                                <path d="M1040,113.348l5,5,5-5" transform="translate(-1037.879 -111.227)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="jobs-list-item-salary">
                                        {job.salary}
                                    </div>
                                </div>
                            </div>
                            {selectedJobId == job.id && <JobDetails job={job} />}
                        </div>
                        :
                        <div key={job.id} className='jobs-list-item-container'>
                            <div className="jobs-list-item" onClick={() => handleJobClick(job.id)}>
                                <div className="jobs-list-item-date">
                                    {job.date_from_str?.substring(0, 10)}
                                </div>
                                <div className="jobs-list-item-content">
                                    <div className="jobs-list-item-name">
                                        {job.name}
                                    </div>
                                    <div className="jobs-list-item-salary">
                                        {job.salary}
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="33.309" height="19.154" viewBox="0 0 33.309 19.154" style={{ marginRight: '5vw' }}>
                                        <path d="M1040,113.348l13.119,13.119,13.119-13.119" transform="translate(-1036.464 -109.813)" fill="none" stroke={selectedJobId == job.id ? "#ffffff" : "#707070"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="5" />
                                    </svg>
                                </div>
                            </div>
                            {selectedJobId == job.id && <JobDetails job={job} />}
                        </div>
                    ))}
                </div>
            </div>
        )
    };

    const JobDetails = ({ job }) => (
        <div className="job-details">
            <table>
                <tbody>
                    <tr>
                        <td><FormattedMessage id={'jobs.jobDescription'} /></td>
                        <td>{job.descript}</td>
                    </tr>
                    <tr>
                        <td><FormattedMessage id={'jobs.jobRequirement'} /></td>
                        <td>{job.requirement}</td>
                    </tr>
                    <tr>
                        <td><FormattedMessage id={'jobs.jobWorkingHour'} /></td>
                        <td>{job.working_hours}</td>
                    </tr>
                    <tr>
                        <td><FormattedMessage id={'jobs.jobBenefit'} /></td>
                        <td>{job.benefit}
                            {!isMobile &&
                                <svg width="130" viewBox="0 0 196.184 52" className="job-apply-button" onClick={() => nav(prefix + `/careers/${params.jobsNature}/application/${job.id}`, { state: { job } })}>
                                    <defs>
                                        <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                                            <stop offset="0" stopColor="#fb8989" />
                                            <stop offset="1" stopColor="#fe0000" />
                                        </linearGradient>
                                    </defs>
                                    <rect width="196.184" height="52" rx="10" fill="url(#linear-gradient)" />
                                    <text transform="translate(98.092 38)" fill="#fff" fontSize="28" fontFamily="PingFangHK-Regular, PingFang HK" letterSpacing="0.05em"><tspan x="-58.1" y="0">應徵工作</tspan></text>
                                </svg>
                            }
                        </td>
                    </tr>
                    {isMobile &&
                    <tr>
                        <td colSpan="2" style={{ width: '100%' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="98.092" height="26" viewBox="0 0 98.092 26" onClick={() => nav(prefix + `/careers/${params.jobsNature}/application/${job.id}`, { state: { job } })}>
                                <defs>
                                    <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                                        <stop offset="0" stopColor="#fb8989" />
                                        <stop offset="1" stopColor="#fe0000" />
                                    </linearGradient>
                                </defs>
                                <g  transform="translate(-2556 -1747)">
                                    <g transform="translate(0 -17)">
                                        <rect width="98.092" height="26" rx="10" transform="translate(2556 1764)" fill="url(#linear-gradient)" />
                                        <text transform="translate(2605 1783)" fill="#fff" font-size="16" font-family="PingFangHK-Regular, PingFang HK" letterSpacing="0.05em">
                                            {isEng?
                                            <tspan x="-39" y="0">Apply Job</tspan>
                                            :
                                            <tspan x="-33.2" y="0">應徵工作</tspan>
                                            }
                                        </text>
                                    </g>
                                </g>
                            </svg>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    );

    return (
        <div className='jobs'>
            <div className="jobs-background">
                <img src={prefix + '/images/recruit_background.png'} />
                <span className="jobs-title" style={{ letterSpacing: isEng?'0':'1.5vw' }}>
                    <FormattedMessage id={'jobs.title'} />
                </span>
            </div>
            <NavBar />
            <div className='jobs-content-background' />
            <JobsContent />
        </div>
    )
};

export default Jobs;